module.exports = __webpack_public_path__ + "img/Triangle_Up.73ed63c4.svg";